import React, { useEffect, useState } from 'react';
import { CART_URL } from '../utils/constants';
import { DownloadIcon, CreditCardIcon, LockIcon } from 'lucide-react';
import { useGeoPricing } from '../utils/geoPricing';
import { trackAddToCart } from '../utils/metaPixel';
export function PricingSection() {
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  const {
    formattedSalePrice,
    formattedComparePrice
  } = useGeoPricing();
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60).toString().padStart(2, '0');
  const seconds = (timeLeft % 60).toString().padStart(2, '0');
  return <>
      {/* Pricing Card */}
      <section className="py-10 md:py-16 px-4 bg-white border-y border-gray-100" data-id="element-182">
        <div className="max-w-3xl mx-auto bg-cream-dark rounded-3xl shadow-2xl overflow-hidden border-2 border-caramel" data-id="element-183">
          {/* Header */}
          <div className="bg-urgency-red text-white text-center py-4 px-6" data-id="element-184">
            <h3 className="font-heading font-bold text-2xl md:text-3xl uppercase tracking-wider" data-id="element-185">
              AHORRAS 60% HOY
            </h3>
            <p className="text-sm md:text-base mt-1 font-medium opacity-90" data-id="element-186">
              Reserva válida por 15 minutos. Si no entras, tu descuento puede
              pasar a la siguiente persona.
            </p>
          </div>

          <div className="p-6 md:p-12 text-center" data-id="element-187">
            {/* Regular Price */}
            <p className="text-gray-500 font-semibold uppercase tracking-widest text-sm mb-1" data-id="element-188">
              Valor regular:
            </p>
            <p className="text-3xl md:text-4xl font-heading font-bold text-gray-400 line-through decoration-urgency-red decoration-2 mb-4 md:mb-6" data-id="element-189">
              {formattedComparePrice}
            </p>

            {/* Sale Price */}
            <p className="text-brown-dark font-bold uppercase tracking-wide text-base md:text-lg mb-3" data-id="element-190">
              HOY ACCEDES POR UN PAGO ÚNICO DE:
            </p>
            <p className="text-5xl md:text-7xl font-heading font-extrabold text-caramel mb-6 md:mb-8 drop-shadow-sm" data-id="element-191">
              {formattedSalePrice}
            </p>

            {/* CTA Button */}
            <a href={CART_URL} onClick={trackAddToCart} className="block w-full bg-cta-green hover:bg-green-700 text-white font-heading font-bold text-xl md:text-2xl py-5 px-8 rounded-xl shadow-[0_10px_20px_rgba(22,163,74,0.3)] transition-all transform hover:-translate-y-1 hover:scale-[1.02] animate-pulse-glow mb-5" data-id="element-192">
              QUIERO MI RECETARIO
            </a>

            {/* Below button */}
            <p className="flex items-center justify-center text-gray-600 font-medium text-sm mb-4" data-id="element-193">
              <DownloadIcon className="w-4 h-4 mr-2 text-caramel-dark" data-id="element-194" />
              Acceso inmediato por email
            </p>

            {/* Secure Payment */}
            <div className="pt-4 border-t border-gray-200 flex flex-col items-center" data-id="element-195">
              <div className="flex items-center gap-2 mb-3" data-id="element-196">
                <LockIcon className="w-4 h-4 text-success-green" data-id="element-197" />
                <p className="text-xs text-gray-400 font-bold uppercase" data-id="element-198">
                  Pago 100% Seguro
                </p>
              </div>
              <div className="flex gap-3 text-gray-400" data-id="element-199">
                <CreditCardIcon className="w-8 h-8" data-id="element-200" />
                <div className="w-12 h-8 bg-gray-200 rounded flex items-center justify-center text-[10px] font-bold text-gray-500" data-id="element-201">
                  VISA
                </div>
                <div className="w-12 h-8 bg-gray-200 rounded flex items-center justify-center text-[10px] font-bold text-gray-500" data-id="element-202">
                  MC
                </div>
                <div className="w-12 h-8 bg-gray-200 rounded flex items-center justify-center text-[10px] font-bold text-gray-500" data-id="element-203">
                  AMEX
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Timer Section — separate, below pricing */}
      <section className="py-8 md:py-10 px-4 bg-brown-dark" data-id="element-204">
        <div className="max-w-xl mx-auto text-center" data-id="element-205">
          <p className="font-heading font-bold text-lg md:text-xl text-caramel mb-4 uppercase tracking-wider" data-id="element-206">
            Tu descuento expira en:
          </p>
          <div className="inline-flex items-center gap-3 md:gap-4" data-id="element-207">
            <div className="bg-white rounded-xl px-5 py-4 md:px-8 md:py-5 shadow-lg" data-id="element-208">
              <span className="text-4xl md:text-6xl font-heading font-extrabold text-urgency-red" data-id="element-209">
                {minutes}
              </span>
              <p className="text-[10px] md:text-xs text-gray-400 font-bold uppercase mt-1" data-id="element-210">
                Min
              </p>
            </div>
            <span className="text-4xl md:text-5xl font-bold text-white animate-pulse" data-id="element-211">
              :
            </span>
            <div className="bg-white rounded-xl px-5 py-4 md:px-8 md:py-5 shadow-lg" data-id="element-212">
              <span className="text-4xl md:text-6xl font-heading font-extrabold text-urgency-red" data-id="element-213">
                {seconds}
              </span>
              <p className="text-[10px] md:text-xs text-gray-400 font-bold uppercase mt-1" data-id="element-214">
                Seg
              </p>
            </div>
          </div>
        </div>
      </section>
    </>;
}